import React, { useContext, useEffect } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../globalContext/auth/authProvider";
import { userRole } from "../constants";

function withPrivateAccess(Component) {
  return (props) => {
    const [authState] = useContext(AuthContext);
    const navigate = useNavigate();
    useEffect(() => {
      if (
        (_.isEmpty(authState) && !window.location.pathname.includes("dnsd")) ||
        (!window.location.pathname.includes("dnsd") &&
          authState?.currentRole?.id === userRole.DNSD)
      ) {
        localStorage.clear();
        navigate("/login");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    if (
      (_.isEmpty(authState) && !window.location.pathname.includes("dnsd")) ||
      (!window.location.pathname.includes("dnsd") &&
        authState?.currentRole?.id === userRole.DNSD)
    ) {
      return null;
    }

    return <Component {...props} />;
  };
}

export default withPrivateAccess;
